import { useEffect, useState } from 'react';
import { Device } from '../../../../../../../../types/Device';
import SelectChecker from '../../../../../../../../utils/shared/components/Select/SelectChecker/SelectChecker';
import { Button, message, Modal } from 'antd';
import useRecordingStore from '../../../api/recording/recordingStore';
import { ReactComponent as SvgClose } from 'utils/app/assets/icons/Close.svg';

import './styles.css';
import { ModalCameraGrid } from '../../ModalCameraGrid/ModalCameraGrid';
import { useSelectedLayout } from '../../../../../../../../store/useSelectedLayout';

export interface RecordModalProps {
    visible: boolean;
    onOk: (selectedDevices: Device[]) => void;
    onCancel: () => void;
    devices: Device[];
    layoutViewType: string;
    title: string;
    type: 'audio' | 'video' | 'photo';
    setIsModalVisible: (visible: boolean) => void;
}

export const RecordModal: React.FC<RecordModalProps> = ({
    visible,
    onCancel,
    devices,
    title,
    onOk,
    type,
    setIsModalVisible,
}) => {
    const [selectedDevices, setSelectedDevices] = useState<Device[]>([]);
    const [selectionMode, setSelectionMode] = useState<'all' | 'select'>('all');
    const { startRecording, canStartRecording, getDeviceRecordingType } = useRecordingStore();
    const { selectedLayout, setSelectedLayout } = useSelectedLayout();

    const availableDevices = devices.filter((device) => {
        const status = device.currentStatus || '';

        if (!device.online) return false;

        if (type === 'photo') return true;
        if (type === 'video') return !status.includes('пишет видео');
        if (type === 'audio')
            return !status.includes('пишет аудио') && !status.includes('пишет видео');
        return false;
    });

    // const availableDevices = devices.filter((device) => {
    //     const recordingType = getDeviceRecordingType(device.UID, devices);
    //
    //     if (!device.online) {
    //         return false;
    //     }
    //
    //     if (type === 'photo') {
    //         // Для фото доступны все камеры, даже с записью аудио
    //         return true;
    //     } else if (type === 'video') {
    //         // Для видео: доступны камеры без записи или с записью аудио
    //         return !recordingType || recordingType === 'audio';
    //     }
    //     // Для аудио: только камеры без записи
    //     return !recordingType;
    // });

    // const availableDevices = devices.filter((device) => device.online);

    // useEffect(() => {
    //     if (visible) {
    //         setSelectionMode('all');
    //         setSelectedDevices([...availableDevices]);
    //     }
    // }, [visible, availableDevices]);

    const handleOk = () => {
        const targetDevices = selectionMode === 'all' ? availableDevices : selectedDevices;

        if (
            (selectionMode === 'select' && targetDevices.length === 0) ||
            (selectionMode === 'select' && selectedDevices.length === 0)
        ) {
            message.error('Выберите хотя бы одну камеру');
            return;
        }

        if (selectionMode === 'select' && selectedDevices.length === 0) {
            message.error('Выберите хотя бы одну камеру');
            return;
        }

        // if (type !== 'photo') {
        //     startRecording(type, targetDevices, selectedLayout?.uid);
        // }
        onOk(targetDevices);
        setSelectedDevices([]);
        onCancel();
    };

    // const handleOk = () => {
    //     const targetDevices = selectionMode === 'all' ? availableDevices : selectedDevices;
    //
    //     if (targetDevices.length === 0) {
    //         // Не показываем модалку, если нет онлайн устройств
    //         setIsModalVisible(false);
    //         return;
    //     }
    //
    //     onOk(targetDevices);
    //     setIsModalVisible(false);
    // };

    const handleSelectionModeChange = (value: 'all' | 'select') => {
        setSelectionMode(value);
        if (value === 'all') {
            // При выборе "со всех" автоматически выбираем все доступные
            setSelectedDevices([...availableDevices]);
        } else {
            // При ручном выборе сбрасываем выбор
            setSelectedDevices([]);
        }
    };

    return (
        <Modal
            title={
                <div className="modal_header headline small">
                    <span className="modal-title">{title}</span>
                    {<SvgClose className="custom-close-icon" onClick={onCancel} />}
                </div>
            }
            className={'record-modal'}
            visible={visible && availableDevices.length > 0}
            onOk={handleOk}
            destroyOnClose
            onCancel={onCancel}
            footer={[
                <Button
                    key="ok"
                    className="button-base button-type-primary button-size-medium "
                    onClick={handleOk}
                >
                    {type === 'photo' ? 'Сделать фото' : 'Начать запись'}
                </Button>,
            ]}
        >
            <SelectChecker
                label={'Выберите уст-ва:'}
                value={selectionMode}
                overlayClassName={'record-modal-select-checker-overlay'}
                labelClassName={'record-modal-select-checker-label title medium'}
                onChange={(e) => handleSelectionModeChange(e.target.value)}
                options={[
                    { label: 'со всех', value: 'all' },
                    { label: 'выбрать с каких', value: 'select' },
                ]}
            />

            <ModalCameraGrid
                devices={availableDevices}
                selectedDevices={selectionMode === 'all' ? availableDevices : selectedDevices}
                onTileClick={(device) => {
                    if (selectionMode === 'select') {
                        const isSelected = selectedDevices.some((d) => d.UID === device.UID);
                        setSelectedDevices(
                            isSelected
                                ? selectedDevices.filter((d) => d.UID !== device.UID)
                                : [...selectedDevices, device],
                        );
                    }
                }}
                getTileStatus={(device) => {
                    const recordingType = getDeviceRecordingType(device);
                    return {
                        isDisabled: false, // Все устройства в списке уже доступны
                        tooltip: recordingType ? `Текущая запись: ${recordingType}` : undefined,
                        highlight: recordingType ?? undefined,
                    };
                }}
            />
        </Modal>
    );
};
